<template>
  <!-- Модальное окно Bootstrap 4. Управляется через класс .show и инлайн-стили Vue -->
  <div
      class="modal fade"
      :class="{ 'show d-block': isOpen }"
      tabindex="-1"
      role="dialog"
      style="background: rgba(0, 0, 0, 0.5);"
      v-if="isOpen"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content shadow-lg">

        <!-- Шапка окна -->
        <div class="modal-header bg-light">
          <h5 class="modal-title font-weight-bold text-dark">Создать новый объект</h5>
          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Форма создания -->
        <form @submit.prevent="submitForm">
          <div class="modal-body">

            <!-- Поле: Название -->
            <div class="form-group mb-3">
              <label class="form-label font-weight-bold small text-muted">Название <span class="text-danger">*</span></label>
              <input
                  v-model="form.name"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Введи название объекта"
                  required
              >
            </div>

            <!-- Поле: Адрес -->
            <div class="form-group mb-3">
              <label class="form-label font-weight-bold small text-muted">Address <span class="text-danger">*</span></label>
              <textarea
                  v-model="form.address"
                  rows="2"
                  class="form-control form-control-sm"
                  placeholder="Укажи фактический адрес"
                  required
              ></textarea>
            </div>

            <!-- Координаты: Широта и Долгота (Валидация диапазонов) -->
            <div class="form-row mb-3">
              <div class="form-group col-6 mb-0">
                <label class="form-label font-weight-bold small text-muted">Широта (Latitude)</label>
                <input
                    v-model.number="form.latitude"
                    type="number"
                    step="0.0000001"
                    min="-90"
                    max="90"
                    class="form-control form-control-sm"
                    placeholder="От -90 до 90"
                >
              </div>
              <div class="form-group col-6 mb-0">
                <label class="form-label font-weight-bold small text-muted">Долгота (Longitude)</label>
                <input
                    v-model.number="form.longitude"
                    type="number"
                    step="0.0000001"
                    min="-180"
                    max="180"
                    class="form-control form-control-sm"
                    placeholder="От -180 до 180"
                >
              </div>
            </div>

            <!-- Поле: Описание -->
            <div class="form-group mb-0">
              <label class="form-label font-weight-bold small text-muted">Описание</label>
              <textarea
                  v-model="form.description"
                  rows="3"
                  class="form-control form-control-sm"
                  placeholder="Дополнительная информация об объекте..."
              ></textarea>
            </div>

          </div>

          <!-- Подвал с кнопками управления -->
          <div class="modal-footer bg-light justify-content-between">
            <button
                type="button"
                class="btn btn-secondary btn-sm"
                @click="closeModal"
                :disabled="isSubmitting"
            >
              Отмена
            </button>
            <button
                type="submit"
                class="btn btn-success btn-sm"
                :disabled="isSubmitting"
            >
              <span v-if="isSubmitting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              Сохранить объект
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "geo-location-create-modal",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: '',
        address: '',
        latitude: '',
        longitude: '',
        description: ''
      }
    }
  },
  methods: {
    closeModal() {
      this.resetForm();
      this.$emit("close");
    },
    resetForm() {
      this.form.name = '';
      this.form.address = '';
      this.form.latitude = '';
      this.form.longitude = '';
      this.form.description = '';
    },
    submitForm() {
      this.isSubmitting = true;
      let uri = `/v1/geo-locations/add`;

      axios
          .post(uri, this.form)
          .then(resp => {
            this.$emit("created", resp.data);
            this.closeModal();

            if (this.$store) {
              this.$store.dispatch("addNotification", {
                text: "Объект успешно создан!",
                time: 4,
                color: "success"
              });
            }
          })
          .catch(err => {
            const errorMsg = err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : "Не удалось создать объект";

            if (this.$store) {
              this.$store.dispatch("addNotification", {
                text: errorMsg,
                time: 6,
                color: "danger"
              });
            }
          })
          .finally(() => {
            this.isSubmitting = false;
          });
    }
  }
}
</script>

<style scoped lang="scss">
</style>
